export default {
  // System Common
  'sys.serialNumber': 'N°',
  'sys.status': 'Estado',
  'sys.operation': 'Operación',
  'sys.cancel': 'Cancelar',
  'sys.confirm': 'Confirmar',
  'sys.add': 'Añadir',
  'sys.edit': 'Editar',
  'sys.preview': 'Vista Previa',
  'sys.delete': 'Eliminar',
  'sys.enable': 'Habilitar',
  'sys.disable': 'Deshabilitar',
  'sys.search': 'Buscar',
  'sys.reset': 'Restablecer',
  'sys.total': 'Total {total} elementos',
  'sys.addSuccess': 'Añadido exitosamente',
  'sys.editSuccess': 'Editado exitosamente',
  'sys.deleteSuccess': 'Eliminado exitosamente',
  'sys.enableSuccess': 'Habilitado exitosamente',
  'sys.disableSuccess': 'Deshabilitado exitosamente',
  'sys.addFailed': 'Error al añadir',
  'sys.editFailed': 'Error al editar',
  'sys.deleteFailed': 'Error al eliminar',
  'sys.enableFailed': 'Error al habilitar',
  'sys.disableFailed': 'Error al deshabilitar',
  'sys.confirmDelete': '¿Está seguro de que desea eliminar?',
  'sys.confirmEnable': '¿Está seguro de que desea habilitar?',
  'sys.confirmDisable': '¿Está seguro de que desea deshabilitar?',
  'sys.required': 'Requerido',
  'sys.pleaseSelect': 'Seleccione',
  'sys.pleaseEnter': 'Ingrese',
  'sys.all': 'Todos',
  'sys.enabled': 'Habilitado',
  'sys.disabled': 'Deshabilitado',
  'sys.operator': 'Operador',
  'sys.operateTime': 'Hora de Operación',

  // Email Template Modal
  'email.template.modal.title.edit': 'Editar Plantilla de Correo',
  'email.template.modal.title.add': 'Añadir Plantilla de Correo',
  'email.template.modal.language': 'Idioma',
  'email.template.modal.language.placeholder': 'Seleccione idioma',
  'email.template.modal.businessType': 'Tipo de Negocio',
  'email.template.modal.businessType.placeholder': 'Seleccione tipo de negocio',
  'email.template.modal.subject': 'Asunto del Correo',
  'email.template.modal.subject.placeholder': 'Ingrese asunto del correo',
  'email.template.modal.content': 'Plantilla de Correo',
  'email.template.modal.content.placeholder': 'Ingrese contenido del correo',
  'email.template.modal.sender': 'Remitente a Mostrar',
  'email.template.modal.sender.placeholder': 'Ingrese remitente a mostrar',
  'email.template.modal.format': 'Formato de Correo',
  'email.template.modal.format.placeholder': 'Seleccione formato de correo',
  'email.template.modal.receipt': 'Confirmación de Recepción Requerida',
  'email.template.modal.receipt.placeholder': 'Seleccione si se requiere confirmación de recepción',
  'email.template.modal.receipt.yes': 'Sí',
  'email.template.modal.receipt.no': 'No',

  // Email Config Modal
  'email.config.modal.title.edit': 'Editar Correo',
  'email.config.modal.title.add': 'Añadir Correo',
  'email.config.modal.type': 'Tipo de Correo',
  'email.config.modal.type.placeholder': 'Seleccione tipo de correo',
  'email.config.type.80002001': 'Correo Microsoft',
  'email.config.type.80002002': 'Correo Google',
  'email.config.modal.account': 'Dirección de Correo',
  'email.config.modal.account.placeholder': 'Ingrese dirección de correo',
  'email.config.modal.password': 'Contraseña del Correo',
  'email.config.modal.password.placeholder': 'Ingrese contraseña del correo',
  'email.config.modal.smtp': 'SMTP',
  'email.config.modal.smtp.placeholder': 'Ingrese dirección SMTP',
  'email.config.modal.port': 'Puerto',
  'email.config.modal.port.placeholder': 'Ingrese número de puerto',

  // Email Template List
  'email.template.list.title': 'Lista de Plantillas de Correo',
  'email.template.list.search.businessType': 'Tipo de Negocio',
  'email.template.list.search.language': 'Idioma',
  'email.template.list.search.button': 'Buscar',
  'email.template.list.search.reset': 'Restablecer',
  'email.template.list.add': 'Añadir',
  'email.template.list.edit': 'Editar',
  'email.template.list.enable': 'Habilitar',
  'email.template.list.disable': 'Deshabilitar',
  'email.template.list.delete': 'Eliminar',
  'email.template.list.delete.confirm': '¿Está seguro de que desea eliminar?',
  'email.template.list.status.enabled': 'Habilitado',
  'email.template.list.status.disabled': 'Deshabilitado',
  'email.template.list.operator': 'Operador',
  'email.template.list.operateTime': 'Hora de Operación',

  // Email Config List
  'email.config.list.title': 'Lista de Configuración de Correo',
  'email.config.list.search.status': 'Estado',
  'email.config.list.search.status.all': 'Todos',
  'email.config.list.search.status.enabled': 'Habilitado',
  'email.config.list.search.status.disabled': 'Deshabilitado',
  'email.config.list.search.account': 'Dirección de Correo',
  'email.config.list.search.account.placeholder': 'Ingrese dirección de correo',
  'email.config.list.search.button': 'Buscar',
  'email.config.list.search.reset': 'Restablecer',
  'email.config.list.add': 'Añadir Correo',
  'email.config.list.edit': 'Editar',
  'email.config.list.enable': 'Habilitar',
  'email.config.list.disable': 'Deshabilitar',
  'email.config.list.delete': 'Eliminar',
  'email.config.list.delete.confirm': '¿Está seguro de que desea eliminar?',
  'email.config.list.status.enabled': 'Habilitado',
  'email.config.list.status.disabled': 'Deshabilitado',
  'email.config.list.operator': 'Operador',
  'email.config.list.operateTime': 'Hora de Operación',
};